import { PbDispatch, RootState } from '.';
import { useDispatch, useSelector } from 'react-redux';

export const usePbDispatch: () => PbDispatch = useDispatch;
export const usePbSelector: <T>(selector: (state: RootState) => T) => T =
    useSelector;
